(function(){
    'use strict'

    angular
    .module('app.devengados')
    .controller('EditarOtroDevengado', EditarOtroDevengado);

    EditarOtroDevengado.$inject = ['$compile', '$q', '$scope', '$animationsSrv', '$routeParams','DevengadosService', 'TiposDevengadosService', 'DeduciblesService', 'CantidadesService', 'VariablesService', 'logger', '$location', 'CuentasContablesService', 'AreasService', 'UserInfoService', 'CoreSrv'];

    function EditarOtroDevengado($compile, $q, $scope, $animationsSrv, $routeParams, DevengadosService, TiposDevengadosService, DeduciblesService, CantidadesService, VariablesService, logger, $location, CuentasContablesService, AreasService, UserInfoService, CoreSrv) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.focusFormula = true;
        vm.tipos = [];
        vm.cantidades = [];
        vm.deducibles = [];
        vm.devengados = [];
        vm.variables = [];
        vm.empleadoPropiedades = [];
        vm.periodoPropiedades = [];
        vm.cuentas = [];
        vm.areas = [];

        vm.devengado = {
            tipo: -1,
            cantidadId: -1,
            deduccionId: -1,
            devengadoId: -1,
            variableId: -1,
            empleadoId: '-1',
            periodoId: '-1',
            formula: '',
            formulaPostCalculoDevengados: '',
            cuentaId: -1,
            areaId: -1,
            aplicarSoloAguinaldo: false
        };

        vm.devengadoId = $routeParams.id ? $routeParams.id : 0;

        getEmpleadoData();
        getPeriodoData();
        var promiseTipos = getTipos();
        var promiseCantidades = getCantidades();
        var promiseDevengados = getDevengados();
        var promiseVariables = getVariables();
        var promiseDeducibles = getDeducibles();
        var promiseCuentas = getCuentas();
        var promiseAreas = getAreas();

        CargarDevengado();

        function getEmpleadoData()
        {
            vm.empleadoPropiedades = CoreSrv.getPropiedadesEmpleado();
        };

        function getPeriodoData()
        {
            vm.periodoPropiedades = CoreSrv.getPropiedadesPeriodo();
        }

        function getTipos(){
            var promise = TiposDevengadosService.getAll()
            .then(function(tipos){
                vm.tipos = tipos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos.');
            }); 
            
            return promise;
        };

        function getCantidades(){
            var promise = CantidadesService.getAll()
            .then(function(cantidades){
                vm.cantidades = cantidades;
            })
            .catch(function(error){
                $logger.error('Error al obtener las cantidades.');
            }); 
            
            return promise;
        };

        function getDevengados(){
            var promise = DevengadosService.getAllOtros()
            .then(function(devengados){
                vm.devengados = devengados;
            })
            .catch(function(error){
                $logger.error('Error al obtener los devengados.');
            }); 
            
            return promise;
        };

        function getVariables(){
            var promise = VariablesService.getAll()
            .then(function(variables){
                vm.variables = variables;
            })
            .catch(function(error){
                $logger.error('Error al obtener las variables.');
            }); 
            
            return promise;
        };

        function getDeducibles(){
            var promise = DeduciblesService.getAll()
            .then(function(deducibles){
                vm.deducibles = deducibles;
            })
            .catch(function(error){
                $logger.error('Error al obtener los deducibles.');
            }); 
            
            return promise;
        };

        function getCuentas(){
            var promise = CuentasContablesService.getAll(UserInfoService.getCompaniaId())
            .then(function(cuentas){
                vm.cuentas = cuentas;
            })
            .catch(function(error){
                $logger.error('Error al obtener las cuentas.');
            }); 
            
            return promise;
        };

        function getAreas(){
            var promise = AreasService.getAll(UserInfoService.getCompaniaId())
            .then(function(areas){
                vm.areas = areas;
            })
            .catch(function(error){
                $logger.error('Error al obtener las areas.');
            }); 
            
            return promise;
        };

        function CargarDevengado(){
            $q.all([promiseTipos, promiseCantidades, promiseDevengados, promiseVariables, promiseDeducibles, promiseCuentas, promiseAreas]).then(getDevengado);
        }

        function getDevengado(){

            if(vm.devengadoId != 0){
                var promise = DevengadosService.getByIdOtros(vm.devengadoId);

                promise
                .then(function(devengado){
                    devengado.cuentaId = devengado.cuentaId == null ? -1 : devengado.cuentaId; 
                    devengado.areaId = devengado.areaId == null ? -1 : devengado.areaId; 
                    vm.devengado = devengado;
                    vm.devengado.cantidadId = -1;
                    vm.devengado.deduccionId = -1;
                    vm.devengado.devengadoId = -1;
                    vm.devengado.variableId = -1;
                    vm.devengado.empleadoId = '-1';
                    vm.devengado.periodoId = '-1';

                    var formulaHtml = $(vm.devengado.formulaHtml);
                    $compile(formulaHtml) ($scope);
                    formulaHtml.appendTo($('.formula'));

                    var formulaPostHtml = $(vm.devengado.formulaPostCalculoDevengadosHtml);
                    $compile(formulaPostHtml) ($scope);
                    formulaPostHtml.appendTo($('.formulaPost'));
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el devengado: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        vm.save = function(){

            $scope.submitted = true;

            if(vm.devengado.tipo == -1){
                $scope.devengadoForm.tipoId.$setValidity("different", false);
            }

            if($scope.devengadoForm.$valid){
                if(!vm.devengado.id){
                    saveDevengado();
                }
                else if($scope.devengadoForm.$dirty){
                    updateDevengado();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveDevengado() {
            var promise = DevengadosService.saveOtros(vm.devengado);
            
            promise
            .then(function(response){
                logger.success('Devengado creada con éxito.');
                clearDevengadoData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el devengado: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateDevengado(){
            var promise = DevengadosService.updateOtros(vm.devengado);
            
            promise
            .then(function(response){
                logger.success('Devengado modificado con éxito.');
                $location.path('/otros-devengados');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el devengado: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearDevengadoData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.devengado = {
                tipo: -1,
                cantidadId: -1,
                deduccionId: -1,
                devengadoId: -1,
                variableId: -1,
                empleadoId: '-1',
                periodoId: '-1',
                formula: '',
                formulaPostCalculoDevengados: '',
                cuentaId: -1,
                areaId: -1,
                aplicarSoloAguinaldo: false
            };
            // Set back to pristine.
            $scope.devengadoForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.devengadoForm.$setUntouched();
        };

        vm.variablesChange = function(){
            addvalueToFormula(vm.variables, vm.devengado.variableId, '#');

        };

        vm.devengadosChange = function(){
            addvalueToFormula(vm.devengados, vm.devengado.devengadoId, '&');
        };

        vm.deduciblesChange = function () {
            addvalueToFormula(vm.deducibles, vm.devengado.deduccionId, '');
        };

        vm.cantidadesChange = function(){
            addvalueToFormula(vm.cantidades, vm.devengado.cantidadId, '@');
        };

        vm.empleadoChange = function(){

            if(vm.devengado.empleadoId == '-1') return;

            setFormulaValue('$' + vm.devengado.empleadoId);
        };

        vm.periodoChange = function(){
            
            if(vm.devengado.periodoId == '-1') return;

            setFormulaValue('~' + vm.devengado.periodoId);
        };

        vm.tiposChange = function(){
            if(vm.devengado.tipo == -1){
                $scope.devengadoForm.tipoId.$setValidity("different", false);
            }
            else{
                $scope.devengadoForm.tipoId.$setValidity("different", true);
            }
        };

        function addvalueToFormula(currentList, modelValue, prefix){
            var item = currentList.find(function(el){
                return el.id == modelValue;
            });

            if(item && item.codigo){

                setFormulaValue(prefix + item.codigo);
            }
        };

        function setFormulaValue(value){
            if(vm.focusFormula)
            {
                UpdateFormulaValue(value);
            }
            else{
                UpdatePostFormulaValue(value);
            }
        };

        function UpdateFormulaValue(value){
            if(vm.devengado.formula == undefined || vm.devengado.formula == null) vm.devengado.formula = '';

            var formulaInput = document.getElementById("myformula");
            var start = formulaInput.selectionStart;
            var end = formulaInput.selectionEnd;

            // update the value with our text inserted
            vm.devengado.formula = vm.devengado.formula.slice(0, start) + value + vm.devengado.formula.slice(end);

            // update cursor to be at the end of insertion
            formulaInput.selectionStart = formulaInput.selectionEnd = start + value.length;
        };

        function UpdatePostFormulaValue(value){
            if(vm.devengado.formulaPostCalculoDevengados == undefined || vm.devengado.formulaPostCalculoDevengados == null) vm.devengado.formulaPostCalculoDevengados = '';

            var formulaInput = document.getElementById("myformulaPost");
            var start = formulaInput.selectionStart;
            var end = formulaInput.selectionEnd;

            // update the value with our text inserted
            vm.devengado.formulaPostCalculoDevengados = vm.devengado.formulaPostCalculoDevengados.slice(0, start) + value + vm.devengado.formulaPostCalculoDevengados.slice(end);

            // update cursor to be at the end of insertion
            formulaInput.selectionStart = formulaInput.selectionEnd = start + value.length;
        };

    }
})();